import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import Greetings from './components/Greetings';
import StepTab from './components/StepTab';

const Mandate = () => {
  const { sale } = useSelector((state) => state.sellerSales);
  const { onboardedUser, steps, currentStep, mandate: { sign_person }} = useSelector((state) => state.sellerMandates);
  const { signatories } = useSelector((state) => state.sellerSalesUsers);
  const [validSteps, setValidSteps] = useState([])

  useEffect(() => {
    const userValid = (['first_name', 'last_name', 'phone_number', 'birth_date', 'family_situation'].every(key => onboardedUser[key]))
    const saleValid = sale.buying_year != null
    const situationValid = ['solo_owner', 'n_owners_solo_signer'].includes(sign_person) || (sign_person === 'n_owners_n_signers' && signatories.length > 1)
    
    let validStepNumbers = []
    if (userValid && saleValid) validStepNumbers.push(1);
    if (userValid && saleValid && situationValid) validStepNumbers.push(2);

    setValidSteps(validStepNumbers);
  }, [onboardedUser, sale.buying_year, sign_person, signatories]);

  return (
    <div className='flex flex-col gap-6' data-testid='Mandate'>
      <Greetings />

      <div className='flex gap-4 w-min mx-auto p-3 bg-white rounded-xl border border-ih-blue-20'>
        {steps.map((step) => {
          return (
            <StepTab key={step.number} step={step} currentStep={currentStep} validSteps={validSteps} />
          )
        })}
      </div>

      <div className='w-full md:w-fit mx-auto md:p-10 md:shadow-ih-1 md:rounded-3xl md:bg-white mdborder'>
        <currentStep.component />
      </div>
    </div>
  );
}

export default Mandate;
